export const API_BASE_URL = 
//"https://tse-consultant-int-backend-app-service.azurewebsites.net";
//"https://bureau-tse-c-int-backend.azurewebsites.net";
//"https://tse-consultant-int-backend-app.azurewebsites.net";
//"https://tse-consultant-int-backend20240801014024.azurewebsites.net";
//"https://localhost:7171";
//"http://tse-consultant-int-app.runasp.net"
""